import { uuid } from '@repo-level/core-front';
import { immer } from 'helpers/zustand';
import type { TFunction } from 'i18next';
import type React from 'react';
import createStore from 'zustand';

export enum TooltipTypes {
  SUCCESS = 0,
  WARNING = 1,
  INFO = 2,
  ERROR = 3,
}

export interface GlobalTooltipState {
  tooltip:
    | {
        id: string;
        type: TooltipTypes;
        title: React.ReactNode;
        text?: React.ReactNode;
        button?: JSX.Element;
        icon?: JSX.Element;
        animate: boolean;
        translate: boolean;
      }
    | undefined;
}

export interface GlobalTooltipConfig {
  type: TooltipTypes;
  title: React.ReactNode;
  text?: React.ReactNode;
  button?: JSX.Element;
  icon?: JSX.Element;
  id?: string;
  animate?: boolean;
}

export interface GlobalTooltipConfigWithTranslation {
  type: TooltipTypes;
  title: ((t: TFunction) => string) | string;
  text?: ((t: TFunction) => string) | string;
  button?: JSX.Element;
  icon?: JSX.Element;
  id?: string;
  animate?: boolean;
  translate: boolean;
}

export interface GlobalTooltipActions {
  show(config: GlobalTooltipConfig): void;
  show(config: GlobalTooltipConfigWithTranslation): void;
  show(config: any): void;

  remove: () => void;
}

const [useGlobalTooltipStore, globalTooltipStoreApi] = createStore(
  immer<GlobalTooltipState & GlobalTooltipActions>((set) => ({
    tooltip: undefined,
    show: ({
      type,
      title,
      text,
      id,
      animate = true,
      translate = false,
      button,
      icon,
    }: any) =>
      set((state) => {
        state.tooltip = {
          id: id == null ? uuid() : id,
          type,
          title,
          text,
          animate,
          translate,
          button,
          icon,
        };
      }),
    remove: () => set((state) => void (state.tooltip = undefined)),
  }))
);

export { useGlobalTooltipStore, globalTooltipStoreApi };
